export default {
  computed: {
    showNotificationTop() {
      return true
    },
  },
}
